export const PROD = 'prod';
export const QA = 'qa';